import getGlobalObject from './getGlobalObject';
import isBatchingEnabled from './isBatchingEnabled';
import {createSnHttp} from '@servicenow/ui-utils';

const root = getGlobalObject();
const {navigator} = root;

const createSnHttpForRest = createSnHttp({
	xsrfToken: root.g_ck,
	xTransactionSource: root.transaction_source,
	maxConcurrent: navigator && navigator.userAgent.indexOf('Trident/7.0') !== -1 ? 1 : 4,
	batching: isBatchingEnabled(root)
});

export default createSnHttpForRest;
